module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGhJREFUeNpidHFxYcAD+IH4MBDfBOIIIP7LxIAffARiDyA2AOLpQMzIAiSOAPF/ILaFKjoMpWH8Z1DTzwDxW5gNjGgmM+KwEWyDDZqgLRpfAohXAPEcIK4k5AeQp3cB8SUgzgA5HSDAABvsESeVLBU9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/hot/icon_more.png
// module id = TS/8
// module chunks = 1